
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import CollapseItem from '@/components/collapse.vue';
import selectProducts from '@/components/selectProducts.vue';
import uploadImg from "@/components/upload-img.vue"
import Message from '@/components/message.vue';

import Switch from '@/components/switch.vue';

import {
	activityOnePriceActivityOnePriceInfo,
	activityOnePriceActivityOnePriceSave,
	activityOnePriceActivityOneChoosePriceProductList,
	activityOnePriceActivityOneChooseProductVerify
} from "@/api/live";


const SPECS = [
	{ title: 'SpecTitle', key: 'SpecValue' },
	{ title: 'SpecTitle2', key: 'SpecValue2' },
	{ title: 'SpecTitle3', key: 'SpecValue3' },
	{ title: 'SpecTitle4', key: 'SpecValue4' },
	{ title: 'SpecTitle5', key: 'SpecValue5' }
];

@Component({
	name: '',
	components: {
		PageFooter,
		CollapseItem,
		selectProducts,
		'slz-message': Message,
		'slz-switch': Switch,
	}
})


export default class FixedPriceDetails extends Vue {
	private pageloading = false
	private form: any = {
		Id: 0,
		ActivityOnePriceState: 0,
		ActivityName: '',
		StartTime: '',
		EndTime: '',
		ActivityDescription: '',
		FullCount: undefined,
		GroupPrice: undefined,
		IsOpenCycleDiscount: true,
		SingleIdMaxJoinCount: undefined,
		ThirdRolePrice: undefined,
		SecondRolePrice: undefined,
		FirstRolePrice: undefined,
		ActivityOnePriceProductDtos: []
	}
	private comparelist = [
		{ value: 1, label: "等于" },
		{ value: 2, label: "大于" },
		{ value: 3, label: "大于或等于" },
		{ value: 4, label: "小于" },
		{ value: 5, label: "小于或等于" },
	];
	private ActivityExchangeBuyProductItemList: any = []
	private total = 0
	private pageSize = 10
	private pageNo = 1
	private saveShow = false
	private exchangeGoods: any = []
	private productPopVisible = false

	private mounted() {
		if (Number(this.$route.query.Id)) {
			this.getInfo()
		}
	}

	private handleDeleteItem(row) {
		this.form.ActivityOnePriceProductDtos = this.form.ActivityOnePriceProductDtos.filter((v) => {
			return v.Id != row.Id;
		});
	}
	private async handleSelectedProducts(list) {

		if (list.length + this.form.ActivityOnePriceProductDtos.length > 999) {
			this.$message.error('最多选择999件')
			return
		}

		await this.checkProducts(list);


		list = list.map(item => {
			return {
				...item,
				ProductId: item.Id,
				MainImgUrlComplete: item.ImgUrlComplete,
				SpecBacthGroupPrice: undefined,
				SpecBacthThirdRolePrice: undefined,
				SpecBacthSecondRolePrice: undefined,
				SpecBacthFirstRolePrice: undefined,
				SpecBacthSpreadPrice: undefined,
				ActivityOnePriceProductSpecDtos: [],
				skus: []
			}
		})
		this.form.ActivityOnePriceProductDtos.push(...list);
		this.getProductSkus(list);
		this.productPopVisible = false
	}
	private checkProducts(list) {
		return new Promise(async (resolve, reject) => {
			let ids = list.map(item => {
				return item.Id
			});

			try {
				let res = await activityOnePriceActivityOneChooseProductVerify({
					ProductIds: ids
				})
				if (res.IsSuccess) {
					resolve(true)
				} else {
					reject();
				}
			} catch (err) {
				reject();
			}
		})

	}
	private priceChange(e, key, index) {
		let value = e.target.value
		this.form.ActivityOnePriceProductDtos[index].ActivityOnePriceProductSpecDtos.map(item => {
			item[key] = value;
			return item;
		})
	}
	private handleDeleteProduct(index) {
		this.form.ActivityOnePriceProductDtos.splice(index, 1)
	}
	private async getProductSkus(list) {
		let ids = list.map(item => {
			return item.Id
		});

		try {
			let res = await activityOnePriceActivityOneChoosePriceProductList({
				ProductIds: ids
			})
			if (res.IsSuccess) {
				this.form.ActivityOnePriceProductDtos.map(item => {
					res.Result.map(product => {
						if (item.ProductId === product.ProductId) {

							let skus = [];
							SPECS.map(spec => {
								if (product[spec.title]) {
									skus.push(
										{
											title: product[spec.title],
											key: spec.key
										}
									)
								}
							})
							item.skus = skus;

							item.ActivityOnePriceProductSpecDtos = product.ActivityOnePriceChooseProductSpecDtos.map(sku => {
								return {
									...sku,
									GroupPrice: undefined,
									ThirdRolePrice: undefined,
									SecondRolePrice: undefined,
									FirstRolePrice: undefined,
									SpreadPrice: undefined
								}
							})
						}
					})
					return item;
				})
			}
		} finally {
		}
	}

	private async getInfo() {
		try {
			this.pageloading = true
			let res = await activityOnePriceActivityOnePriceInfo({
				Id: this.$route.query.Id
			})
			if (res.IsSuccess) {
				let form = res.Result;
				form.Id = this.$route.query.Id;

				form.ActivityOnePriceProductDtos.map(item => {
					item.Id = item.ProductId;

					let skus = [];
					SPECS.map(spec => {
						if (item[spec.title]) {
							skus.push(
								{
									title: item[spec.title],
									key: spec.key
								}
							)
						}
					})
					item.skus = skus;
					return item;
				})


				this.form = form;

			}
		} finally {
			this.pageloading = false
		}
	}
	private async confirmSave() {
		this.pageloading = true;
		try {
			let res: any = await activityOnePriceActivityOnePriceSave({ ActivityOnePriceSaveDto: this.form })
			if (res.IsSuccess) {
				this.$message.success('保存成功')
				this.$router.go(-1)
			}
		} finally {
			this.pageloading = false
		}
	}
	private tosave() {
		// console.log(this.form);
		// return
		// let two = /^\d+(\.\d{1,2})?$/
		// if (!this.form.ActivityName) {
		// 	this.$message.error('请输入活动名称')
		// 	return
		// }
		// if (!this.form.StartTime || !this.form.EndTime) {
		// 	this.$message.error('请完善活动时间')
		// 	return
		// }
		// if (new Date(this.form.StartTime).getTime() > new Date(this.form.EndTime).getTime()) {
		// 	this.$message.error('结束时间必须大于开始时间')
		// 	return
		// }
		// if(new Date(this.form.StartTime).getTime() < new Date().getTime()){
		// 	this.$message.error('请设置未来时间作为活动时间')
		// 	return
		// }
		// if (!this.form.ActivityDescription) {
		// 	this.$message.error('请填写活动规则，方便用户更好了解活动细则')
		// 	return
		// }
		// if (this.form.FullCount < 2 || this.form.FullCount > 999) {
		// 	this.$message.error('请输入2~999的商品数量')
		// 	return
		// }
		// if (this.form.GroupPrice < 0.01 || this.form.GroupPrice > 1000000) {
		// 	this.$message.error('请输入0.01~100万的下单金额')
		// 	return
		// }
		// if (this.form.SingleIdMaxJoinCount < 0 || this.form.SingleIdMaxJoinCount > 9999) {
		// 	this.$message.error('请输入0~9999的活动限制')
		// 	return
		// }

		// this.saveShow = true
		this.confirmSave();
	}



}
